import { FC, SVGProps } from "react";

const CopyIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="currentcolor" {...props}>
      <path
        d="M10.75 2.66667H4.91667C3.46533 2.66667 2.66667 3.46533 2.66667 4.91667V10.75C2.66667 12.2013 3.46533 13 4.91667 13H10.75C12.2013 13 13 12.2013 13 10.75V4.91667C13 3.46533 12.2013 2.66667 10.75 2.66667ZM12 10.75C12 11.638 11.638 12 10.75 12H4.91667C4.02867 12 3.66667 11.638 3.66667 10.75V4.91667C3.66667 4.02867 4.02867 3.66667 4.91667 3.66667H10.75C11.638 3.66667 12 4.02867 12 4.91667V10.75ZM1 2.24666V8.08667C1 8.88534 1.32206 9.08201 1.42806 9.14734C1.66406 9.29134 1.73726 9.59934 1.59326 9.83468C1.4986 9.98868 1.33468 10.0733 1.16602 10.0733C1.07735 10.0733 0.986607 10.0493 0.905273 10C0.304607 9.632 0 8.98867 0 8.08667V2.24666C0 0.818663 0.819411 0 2.24674 0H8.08659C9.20992 0 9.74667 0.492647 10 0.905314C10.144 1.14065 10.07 1.44865 9.83464 1.59265C9.59864 1.73732 9.29197 1.66266 9.1473 1.42733C9.08263 1.32133 8.88526 0.999349 8.08659 0.999349H2.24674C1.36141 1.00002 1 1.36133 1 2.24666Z"
      />
    </svg>
  );
};

export default CopyIcon;
